import * as httpTool from '../http-tools'
import * as apiConst from '../api-const'
export default {
    //获取固定表单数据状态
    getFormStatus (params) {
        return httpTool.fetchPost(apiConst.getFormStatusUrl,params)
    },
    //新生儿入住评估单添加
    addNewBornCheckAssessData (params) {
        return httpTool.fetchPost(apiConst.addNewBornCheckAssessDataUrl,params)
    },
    //新生儿入住评估单详情
    getNewBornCheckAssessFind (params) {
        return httpTool.fetchPost(apiConst.getNewBornCheckAssessFindUrl,params)
    },
    //新生儿入住评估单编辑
    updateNewBornCheckAssessData (params) {
        return httpTool.fetchPost(apiConst.updateNewBornCheckAssessDataUrl,params)
    },
    //新生儿满月评估单添加
    addNewbornFullmoonAssessData (params) {
        return httpTool.fetchPost(apiConst.addNewbornFullmoonAssessDataUrl,params)
    },
    //新生儿满月评估单详情
    getNewbornFullmoonAssessFind (params) {
        return httpTool.fetchPost(apiConst.getNewbornFullmoonAssessFindUrl,params)
    },
    //新生儿满月评估单编辑
    updateNewNewbornFullmoonAssessData (params) {
        return httpTool.fetchPost(apiConst.updateNewNewbornFullmoonAssessDataUrl,params)
    },
    //妈妈入住评估单添加
    addMaterCheckAssessData (params) {
        return httpTool.fetchPost(apiConst.addMaterCheckAssessDataUrl,params)
    },
    //妈妈入住评估单详情
    getMaterCheckAssessFind (params) {
        return httpTool.fetchPost(apiConst.getMaterCheckAssessFindUrl,params)
    },
    //妈妈入住评估单编辑
    updateMaterCheckAssessData (params) {
        return httpTool.fetchPost(apiConst.updateMaterCheckAssessDataUrl,params)
    },
    //出院证明填写/编辑
    updateMaternalLeaveProveRecor (params,files,fieldName){
        return httpTool.newFormfetchPostFile(apiConst.updateMaternalLeaveProveRecordUrl,params,files,fieldName)
    },
    //出院证明详情
    getMaternalLeaveProveRecord (params){
        return httpTool.fetchPost(apiConst.MaternalLeaveProveRecordUrl,params)
    },
    //医院就诊单编辑
    updateMaternalHospitalChecklistRecord (params,files,fieldName){
        return httpTool.newFormfetchPostFile(apiConst.updateMaternalHospitalChecklistRecordUrl,params,files,fieldName)
    },
    //医院就诊单详情
    getMaternalHospitalChecklistRecord (params){
        return httpTool.fetchPost(apiConst.MaternalHospitalChecklistRecordUrl,params)
    },
    //宝宝足印编辑
    updateBabyFootRecord (params,filesIn,filesOut){
        return httpTool.fetchPostFileFootprint(apiConst.updateBabyFootRecordUrl,params,filesIn,filesOut)
    },
    //宝宝足印详情
    getBabyFootRecord (params){
        return httpTool.fetchPost(apiConst.getBabyFootRecordUrl,params)
    },
 getSpecialReport(params) {
    return httpTool.fetchPost(apiConst.getSpecialReport, params)

  },
   getSpecialReportRoom(params) {
    return httpTool.fetchPost(apiConst.getSpecialReportRoom, params)

  },
   getSpecialReportMeal(params) {
    return httpTool.fetchPost(apiConst.getSpecialReportMeal, params)

  },
  //获取汇报人列表
  getAgentList(params) {
    return httpTool.fetchPost(apiConst.getMaternalAgentList, params)
  },
  getDepartmentList(params) {
    return httpTool.fetchPost(apiConst.getDepartmentList, params)
  },
  specialReportAdd(params) {
    return httpTool.fetchPost(apiConst.specialReportAdd, params)
  },
  specialReportAddRoom(params) {
    return httpTool.fetchPost(apiConst.specialReportAddRoom, params)
  },
    specialReportAddMeal(params) {
    return httpTool.fetchPost(apiConst.specialReportAddMeal, params)
  },
  getPositionList(params) {
    return httpTool.fetchPost(apiConst.getPositionList, params)
  },
}



// WEBPACK FOOTER //
// ./src/service/api/repository/otherForm-api.js